import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import InnsynMotorvognFilterForm from "./InnsynMotorvognFilterForm";

import {
  handleChange as handleChangeAction,
  handleChangeAll as handleChangeAllAction,
  handleChangeToInitState as handleChangeToInitStateAction,
} from "../../actions/handleChangeAction";
import {
  GET_SINGLE_MOTORVOGN_SUCCESS,
  getSingleMotorvognByQuery as getSingleMotorvognByQueryAction,
} from "../../actions/motorvognActions";
import {
  DatoenErIkkeGyldig,
  DatoIsRequired,
  timeIsNotValid,
} from "../../constants/ErrorMessages";
import { isValidDate, mergeDateAndTime } from "../../utils/date";

function InnsynMotorvognFilterContainer({
  waitingForGetSingleMotorvognByQuery,
}) {
  const dispatch = useDispatch();
  const innsynMotorvognFilterForm = useSelector(
    (state) => state.forms.innsynMotorvognFilterForm,
  );

  const [showSokSpinner, setShowSokSpinner] = useState(false);

  const handleChangeAll = (payload) =>
    dispatch(handleChangeAllAction("INNSYN_MOTORVOGN_FILTER_FORM", payload));

  const isValid = () => {
    let kjennemerkeValidationError = null;
    let datoValidationError = null;
    let tidValidationError = null;
    let understellsnummerValidationError = null;

    if (
      innsynMotorvognFilterForm.tid &&
      typeof innsynMotorvognFilterForm.tid === "object" &&
      isValidDate(innsynMotorvognFilterForm.tid) &&
      !innsynMotorvognFilterForm.dato &&
      !innsynMotorvognFilterForm.understellsnummer
    ) {
      datoValidationError = DatoIsRequired;
    }
    if (
      innsynMotorvognFilterForm.dato &&
      (typeof innsynMotorvognFilterForm.dato !== "object" ||
        !isValidDate(innsynMotorvognFilterForm.dato)) &&
      !innsynMotorvognFilterForm.understellsnummer
    ) {
      datoValidationError = DatoenErIkkeGyldig;
    }
    if (
      innsynMotorvognFilterForm.tid &&
      (typeof innsynMotorvognFilterForm.tid !== "object" ||
        !isValidDate(innsynMotorvognFilterForm.tid)) &&
      !innsynMotorvognFilterForm.understellsnummer
    ) {
      tidValidationError = timeIsNotValid(innsynMotorvognFilterForm.tid);
    }
    if (
      (innsynMotorvognFilterForm.dato || innsynMotorvognFilterForm.tid) &&
      (typeof innsynMotorvognFilterForm.dato === "object" ||
        typeof innsynMotorvognFilterForm.tid === "object") &&
      (isValidDate(innsynMotorvognFilterForm.dato) ||
        isValidDate(innsynMotorvognFilterForm.tid)) &&
      !innsynMotorvognFilterForm.kjennemerke &&
      !innsynMotorvognFilterForm.understellsnummer
    ) {
      kjennemerkeValidationError = "Kjennemerke må velges";
    }
    if (
      innsynMotorvognFilterForm.understellsnummer &&
      (innsynMotorvognFilterForm.kjennemerke ||
        innsynMotorvognFilterForm.dato ||
        innsynMotorvognFilterForm.tid)
    ) {
      understellsnummerValidationError = "Må brukes uten annen filtrering";
    }
    if (
      kjennemerkeValidationError ||
      datoValidationError ||
      tidValidationError ||
      understellsnummerValidationError
    ) {
      handleChangeAll({
        kjennemerkeValidationError,
        datoValidationError,
        tidValidationError,
        understellsnummerValidationError,
      });
      return false;
    }

    return true;
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    handleChangeAll({
      kjennemerkeValidationError: null,
      datoValidationError: null,
      understellsnummerValidationError: null,
    });

    if (
      innsynMotorvognFilterForm &&
      isValid() &&
      (innsynMotorvognFilterForm.kjennemerke ||
        innsynMotorvognFilterForm.understellsnummer)
    ) {
      setShowSokSpinner(true);

      let dato = null;
      const d = innsynMotorvognFilterForm.dato;
      const t = innsynMotorvognFilterForm.tid;
      if (d instanceof Date && !Number.isNaN(d.getTime())) {
        if (t instanceof Date && !Number.isNaN(t.getTime())) {
          dato = mergeDateAndTime(d, t);
        } else {
          dato = new Date(
            d.getFullYear(),
            d.getMonth(),
            d.getDate(),
            0,
            0,
            0,
            0,
          );
        }
      }
      const payload = {
        kjennemerke: innsynMotorvognFilterForm.kjennemerke,
        dato: dato,
        understellsnummer: innsynMotorvognFilterForm.understellsnummer,
      };
      dispatch(
        getSingleMotorvognByQueryAction(payload, GET_SINGLE_MOTORVOGN_SUCCESS),
      )
        .then(() => setShowSokSpinner(false))
        .catch(() => setShowSokSpinner(false));
      handleChangeAll({
        kjennemerkeValidationError: null,
        datoValidationError: null,
        tidValidationError: null,
        understellsnummerValidationError: null,
      });
    }
  };

  const handleOnChange = (e) => {
    if (e.preventDefault !== undefined) e.preventDefault();
    dispatch(
      handleChangeAction(
        "INNSYN_MOTORVOGN_FILTER_FORM",
        e.target.name,
        e.target.value,
      ),
    );
  };

  const handleOnChangeToInitState = () => {
    dispatch(handleChangeToInitStateAction("INNSYN_MOTORVOGN_FILTER_FORM"));
  };

  return (
    <InnsynMotorvognFilterForm
      showSokSpinner={showSokSpinner}
      innsynMotorvognFilterForm={innsynMotorvognFilterForm}
      handleOnChange={handleOnChange}
      handleOnSubmit={handleOnSubmit}
      handleOnChangeToInitState={handleOnChangeToInitState}
    />
  );
}

export default InnsynMotorvognFilterContainer;
